import timedTakeout from './reducers'

export { setTimedTakeout } from './actions'
export { getTimedTakeout } from './selectors'

export default timedTakeout
